<template lang="pug">
.widget(data-history-field="device_type_blacklist")
  .widget-header
    h2.title Device Type Restrictions
  .widget-body
    fieldset.border-0.p-0.m-0(:disabled="disabled")
      .form-group
        label Restricted Devices
        b-form-checkbox(
          v-for="deviceType in deviceTypes"
          :checked="shouldBlock(deviceType)",
          :key="deviceType"
          @input="() => updateValue(deviceType)"
          ) Block {{ deviceType }} devices
</template>

<style lang="scss"></style>

<script>
export default {
  name: 'device-type-targeting',
  props: {
    value: {
      type: [Array],
      required: true,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deviceTypes: ['desktop', 'mobile', 'tablet'],
    };
  },
  methods: {
    shouldBlock(option) {
      return this.value.includes(option);
    },
    updateValue(option) {
      if (this.disabled) return;
      if (this.value.includes(option)) {
        this.$emit(
          'input',
          this.value.filter((item) => item !== option),
        );
      } else {
        this.$emit('input', [...this.value, option]);
      }
    },
  },
};
</script>
